module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/vue-socket.io/~/isarray/index.js
// module id = 601
// module chunks = 10